var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"micwareContainer"},[_c('div',{staticClass:"micwareHeaderContainer"},[_c('div',{staticClass:"headercontent header-color bgc1"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)]),_vm._v(" "),_c('RightBar')],1)]),_vm._v(" "),_c('div',{staticClass:"footer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f956288","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/layouts/rightLayout.vue
// module id = null
// module chunks = 